import { SetColor } from './SetColor';
import { SetLogo } from './SetLogo';

export const Aspect = {
  SetLogo,
  SetColor,
};
